<template>
    <nav class="menu-bar mr-auto">
        <div class="menu-title-responsive align-center justify-content-between">
            <h1>Menu</h1>
            <el-icon @click="isMenuCloseHandle" class="close-menu-bar"><Close /></el-icon>
        </div>
        <ul>
            <li v-for="(item, i) in dlabData.header.navbar" :key="i" :class="item.submenu ? 'is-dropdown' : ''">
                <menu-item :item="item" />
            </li>
        </ul>
    </nav>
</template>

<script>
import { Close } from '@element-plus/icons-vue'
import dlabData from '@/store/store.js'
import MenuItem from './MenuItem.vue'


export default {
    name: 'NavBar',
    components: {
        MenuItem,
        Close
    },
    data() {
        return {
            dlabData,
            isMenuClose: true
        }
    },
    methods: {
        isMenuCloseHandle() {
            this.isMenuClose = false;
            this.$emit('isMenuClose', this.isMenuClose);
        }
    }
}
</script>
<style scoped>

</style>